

import { Navigate } from "react-router-dom";
import { useAuth } from "../../Middleware/context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  return user ? children : <Navigate to="/" />;
};

export default PrivateRoute;
